import { foregroundPaletteVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
import { sizeVariants } from "../../variants/interactions/icongraphy.variants.js";
const cdnIconVariants = tv({
    extend: foregroundPaletteVariants,
    base: 'material-symbols-icon select-none antialiased',
    variants: {
        size: sizeVariants
    },
    defaultVariants: {
        size: '20'
    }
});
export { cdnIconVariants };
